import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const TranslatedText = ({transKey, params = {}}) => {
  const { t } = useTranslation();
  return t(transKey, params);
};

TranslatedText.propTypes = {
  transKey: PropTypes.string.isRequired,
  params: PropTypes.object,
};

export default React.memo(TranslatedText);



// WEBPACK FOOTER //
// /src/components/TranslatedText.jsx